import { useTheme } from "@mui/material";
import { Image, Text, View } from "@react-pdf/renderer";
import { defaultTo, isEmpty } from "lodash";
import {
  PDFHeaderDarkLogoS3,
  PDFHeaderLightLogoS3,
  PDFStyleConfigs,
} from "../../configs";
import { generatePDFImageIconUrl } from "../../utils";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";

export const PDFPageHeader = ({
  isFirstPage = false,
  pageIndex,
  isReview,
  adviserFirmLogo,
  isAppendix,
  shouldRemoveHeading = defaultTo(pageIndex, 0) >
    PDFStyleConfigs.MaxPageIndexToShowMainHeader,
}: {
  isFirstPage?: boolean;
  pageIndex?: number;
  shouldRemoveHeading?: boolean;
  isReview?: boolean;
  adviserFirmLogo?: string;
  isAppendix?: boolean;
}) => {
  const { palette } = useTheme();
  const { pageStyle, typographyStyle } = useAnalysisPDFStyles();

  return (
    <View
      style={
        isFirstPage
          ? {
              ...pageStyle.header,
              height: isReview
                ? PDFStyleConfigs.ReviewFirstPageHeaderHeight
                : PDFStyleConfigs.FirstPageHeaderHeight,
            }
          : {
              ...pageStyle.header,
              height: shouldRemoveHeading
                ? isReview
                  ? PDFStyleConfigs.ReviewPageHeaderHeightWithoutHeading
                  : PDFStyleConfigs.PageHeaderHeightWithoutHeading
                : isReview
                ? PDFStyleConfigs.ReviewPageHeaderHeight
                : PDFStyleConfigs.PageHeaderHeight,
            }
      }
    >
      {isReview ? (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          {!isEmpty(adviserFirmLogo) && (
            <Image
              src={generatePDFImageIconUrl(adviserFirmLogo)}
              style={
                isFirstPage
                  ? { width: 76, height: 76 }
                  : { width: 46, height: 46 }
              }
            />
          )}

          <Image
            src={isFirstPage ? PDFHeaderDarkLogoS3 : PDFHeaderLightLogoS3}
            style={
              isFirstPage
                ? { width: 223, height: 46 }
                : { width: 172, height: 35 }
            }
          />
        </View>
      ) : (
        <Image
          src={isFirstPage ? PDFHeaderDarkLogoS3 : PDFHeaderLightLogoS3}
          style={
            isFirstPage
              ? { width: 223, height: 46 }
              : { width: 172, height: 35 }
          }
        />
      )}

      {!shouldRemoveHeading && (
        <Text
          style={{
            ...(isFirstPage ? typographyStyle.h1 : typographyStyle.h2),
            color: isFirstPage ? palette.common.white : palette.common.black,
          }}
        >
          {isReview
            ? isFirstPage
              ? "Suitability Review"
              : isAppendix
              ? "Appendix"
              : "Platforms selected"
            : "Platform analysis summary"}
        </Text>
      )}
    </View>
  );
};
